import { Component, Input, Output, EventEmitter, ViewChild, OnInit } from "@angular/core";
import { EdpSelectList } from "../../@models/edp-select-list";
import { NgbDropdown } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "edp-select-list",
    templateUrl: "./edp-select-list.component.html",
    styleUrls: ["./edp-select-list.component.scss"],
})
export class EdpSelectListComponent implements OnInit {
    public _optionList: EdpSelectList[];
    @ViewChild(NgbDropdown, { static: true })
    private dropdown: NgbDropdown;

    @Input() set options(options: EdpSelectList[]) {
        this._optionList = options || [];

        const selectedOption = this._optionList.find(option => option.selected);
        this.selected = selectedOption ? selectedOption.text : null;
    }
    @Input() selected: string;
    @Input() halfHeight: boolean;
    @Input() placeholder = "pt.edp.edponline.select_list.search";
    @Input() placement: "bottom-start" | "bottom-end" | "top-start" | "top-end" = "bottom-start";
    @Output() nextOptions = new EventEmitter<EdpSelectList>();
    @Output() openEvent = new EventEmitter<boolean>();
    public isTopDropdown = false;

    ngOnInit(): void {
        if (!!this.placement && this.placement.includes("top")) {
            this.isTopDropdown = true;
        }
    }

    onChangeOption(option: EdpSelectList): void {
        this.selected = option.text;

        this._optionList.forEach(item => {
            item.selected = false;
        });
        option.selected = true;
        this.nextOptions.emit(option);
    }

    onOpen(eventOpen: boolean) {
        this.openEvent.emit(eventOpen);
    }

    closeDropdown() {
        this.dropdown.close();
    }
}
